import { Hero } from "@/pages/home/Hero";
import { Featured } from "@/pages/home/Featured";
import { Bento } from "@/pages/home/Bento";
import { Manifesto } from "@/pages/home/Manifesto";
import { Marquee } from "@/components/Marquee";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee />
      <Featured />
      <Bento />
      <Manifesto />
    </main>
  );
}
